import React, { Component } from 'react'


export  default class BranchListRow extends Component{

    /*constructor(props){
        super(props)
    }*/

    render(){
        var branchList;

        if (this.props.branch_list.length === 0){
            branchList = <tr><td colSpan={5} className="text-center"><span className="text-danger">ไม่พบข้อมูล</span></td></tr>
        }else {

            branchList = this.props.branch_list.map((branch, index) => {
                return (
                    <tr key={index}>
                        <td className="text-center">{ index+1 }</td>
                        <td className="text-center">{ branch.branch_name }</td>
                        <td>{ branch.branch_address }</td>
                        <td className="text-center">{ branch.branch_tel }</td>

                        <td className="text-right">
                            <button className="btn btn-sm btn-warning btn-icon-width"
                                    onClick={this.props.branchsCallbacks.edit.bind(null,branch)}
                            >
                                <i className="fa fa-edit"></i></button>

                            <button className="btn btn-sm btn-danger btn-icon-width"
                                    onClick={this.props.branchsCallbacks.delete.bind(null,branch)}
                            >
                                <i className="fa fa-remove"></i></button>
                        </td>
                    </tr>
                )
            });
        }

        return (
            <div className="card card-accent-info">
                <div className="card-header">
                    <strong>ข้อมูลสาขา</strong>
                </div>
                <div className="card-block">
                    <table className="table table-striped">
                        <thead>
                        <tr>
                            <th className="text-center">#</th>
                            <th className="text-center">สาขา</th>
                            <th className="text-center">ที่อยู่</th>
                            <th className="text-center">เบอร์โทรศัพท์</th>
                            <th className="text-center"></th>
                        </tr>
                        </thead>
                        <tbody>
                        { branchList }
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}